import React, { useEffect, useState } from 'react';
import { useGetMethodizeUrlMutation } from '../../../features/authentication/methodizeApiSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const MethodizeAuthenticateModel = () => {
  const [getMethodizeUrl] = useGetMethodizeUrlMutation();
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getMethodizeUrlAsync();
  }, []);

  const getMethodizeUrlAsync = async () => {
    setIsAuthenticating(true);
    const response = await getMethodizeUrl();
    if (response.error) {
      if (response.error.data.errors)
        setError(response.error.data.errors.Error);
      else
        setError(response.error.data.error);
      setIsAuthenticating(false);
    } else {
      window.location.href = response.data.redirectUrl;
    }
    setIsAuthenticating(true);
  };

  return (
    <div className='white-card h-320'>
      <h5>Methodize</h5>
      {isAuthenticating &&
                <div className='scroll-spinner mt-5 d-flex fs-1 align-item-center justify-content-center'>
                  <FontAwesomeIcon icon={faSpinner} spin  /><span className='ms-3 fs-2'>Authenticating...</span>
                </div>
      }
      {error?.length > 0 &&
                <div className='text-danger mt-4 text-center'>{error}</div>
      }
    </div>
  );
};

export default MethodizeAuthenticateModel;
